import { transition } from './utils';
import css from './tabs.module.scss';

interface Props {
    value: string;
    onChange(value: string): void;
}
export function Tabs({ value, onChange }: Props) {
    return (
        <nav className={css.tabs}>
            {['Feature flags', 'Cache Key'].map(tab => (
                <label key={tab} className={css.tab}>
                    <span>{tab}</span>
                    <input
                        type="radio"
                        name="tabs"
                        checked={value === tab}
                        onChange={() => transition(() => onChange(tab))}
                    />
                </label>
            ))}
        </nav>
    );
}
